module.exports = __webpack_public_path__ + "static/media/feature-assessment.d9f5924a.png";